import React from "react";
import { FiCode, FiZap, FiUsers } from "react-icons/fi";
import "../../styles/challenges.css";

export default function Hackathon() {
  return (
    <div className="challenges-container">
      <section className="challenge-hero">
        <div className="challenge-hero-content">
          <h1>Hackathon</h1>
          <p className="challenge-subtitle">Build. Innovate. Collaborate.</p>
        </div>
      </section>

      <section className="challenge-content">
        <div className="content-wrapper">
          <div className="challenge-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>About the Hackathon</h3>
            </div>
            <p>
              Join us for an intensive coding event where innovators, developers, and entrepreneurs come together 
              to solve real-world problems through creative solutions. Our hackathon provides the perfect platform 
              to build prototypes, collaborate with talented peers, and showcase your ideas to industry leaders.
            </p>
          </div>

          <div className="challenge-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>What to Expect</h3>
            </div>
            <div className="features-grid">
              <div className="feature-card">
                <FiCode className="feature-icon" />
                <h3>Technical Challenges</h3>
                <p>Tackle innovative problems with cutting-edge technologies</p>
              </div>
              <div className="feature-card">
                <FiZap className="feature-icon" />
                <h3>Rapid Development</h3>
                <p>Build working prototypes in limited time</p>
              </div>
              <div className="feature-card">
                <FiUsers className="feature-icon" />
                <h3>Team Collaboration</h3>
                <p>Work with diverse teams of skilled professionals</p>
              </div>
            </div>
          </div>

          <div className="challenge-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>Prize Categories</h3>
            </div>
            <div className="prizes-list">
              <div className="prize-item">
                <span className="prize-rank">First Place</span>
                <span className="prize-value">Professional Recognition</span>
              </div>
              <div className="prize-item">
                <span className="prize-rank">Second Place</span>
                <span className="prize-value">Developer Recognition</span>
              </div>
              <div className="prize-item">
                <span className="prize-rank">Third Place</span>
                <span className="prize-value">Innovation Award</span>
              </div>
            </div>
          </div>

          <div className="challenge-section cta-section">
            <button className="cta-button">Register Your Team</button>
          </div>
        </div>
      </section>
    </div>
  );
}
